import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiError, ConfigServerService, CustomHttp, MessageService } from '../../../../core';
import { PessoaTermoLGPD } from '../pessoa-termo-lgpd';

@Injectable({
    providedIn: 'root'
})
export class PessoaTermoLGPDHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private messageService: MessageService) {
        this.pathApi = `${configServerService.getPathApi()}/pessoatermolgpd`;
    }

    /** Carrega as informações do Termo LGPD da pessoa */
    load(idPessoa: number): Observable<PessoaTermoLGPD> {
        return this.customHttp.get<PessoaTermoLGPD>(`${this.pathApi}/${idPessoa}`);
    }

    /** Remove as informações do Termo LGPD da pessoa */
    delete(entity: PessoaTermoLGPD): Promise<PessoaTermoLGPD> {
        return new Promise<PessoaTermoLGPD>((resolve, reject) => {
            this.messageService.confirm('Deseja realmente remover o Termo LGPD anexado?', 'Confirme').then(result => {
                if (result) {
                    this.customHttp.delete<PessoaTermoLGPD>(`${this.pathApi}/${entity?.id}`)
                        .subscribe(
                            response => {
                                this.messageService.success('', 'Termo LGPD removido com sucesso');
                                resolve(response);
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, error.cause, error);
                                reject(error);
                            }
                        );
                } else {
                    resolve(entity);
                }
            });
        })
    }
}
